module.exports = __webpack_public_path__ + "img/cases-brand-avic-10.c42e51fe.jpg";